import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {

    return (
        <footer>
            <div className='container'>
                <div className='row'>
                    <div className='col-12 text-center'>
                        <p className='p-0 m-0'>
                            <a href="https://www.whirlpool.mx/" className='link-whirlpool' target='_blank' rel="noreferrer">
                                whirlpool.mx
                            </a>
                        </p>

                        <Link to='/termsConditions' target="_blank">
                            Términos y Condiciones de la Actividad
                        </Link>

                        <Link to='/privacyPolicy' target="_blank">
                            &nbsp;y el Aviso de Privacidad.
                        </Link>
                    </div>
                </div>
            </div>

        </footer>
    );
};

export default Footer;
